import { action } from "easy-peasy";
import { IProject, IProjects } from "../interface/projects";
import _ from "lodash";

export const projects: IProjects = {
  projects: [],

  setProjects: action((state, payload) => {
    state.projects = payload;
  }),

  addProject: action((state, payload) => {
    const newProjects = [...state.projects, payload];
    state.projects = newProjects;
  }),

  updateProject: action((state, payload: Partial<IProject>) => {
    const newProjects = [...state.projects];
    const editedProject = newProjects.find(
      (item) => item.projectID === payload.projectID
    );
    if (editedProject) {
      Object.entries(payload).forEach(([key, value]) => {
        if (value) {
          editedProject[key] = value;
        }
      });
    }
    state.projects = newProjects;
  }),
  deleteProject: action((state, payload) => {
    const newProjects = state.projects.filter(
      (item) => item.projectID !== payload.projectID
    );
    state.projects = newProjects;
  }),
  clearProjects: action((state) => {
    state.projects = [];
  }),

  deleteProjectForContract: action((state, payload) => {
    const newProjects = state.projects.filter(
      (item) => item.contractID !== payload
    );
    state.projects = newProjects;
  }),

  updateProjects: action((state, payload) => {
    const updatedProjects: IProject[] = [];

    payload.changes.forEach((_change) => {
      if (_change.projects && _change.projects.length > 0) {
        _change.projects.forEach((_projectID) => {
          const project = payload.projects.find(
            (_project) => _project.projectID === _projectID
          );
          if (project) {
            updatedProjects.push(project);
          }
        });
      } else {
        const contractProjects = payload.projects.filter(
          (_project) => _project.contractID === _change.id
        );
        contractProjects.forEach((_project) => {
          updatedProjects.push(_project);
        });
      }
    });

    state.projects = updatedProjects;
  }),
};
